import { getCurrentToken, getRegion, getEnv, getPartition } from '@adsk/acs-sc-web-platform-api';
import { DocsClass, DOCS_PRODUCTS } from '@adsk/docs-js-sdk';

import PackageJson from '../../package.json';

// /////////////////////////////////////////////////////////////////// //
// SDK configuration
// /////////////////////////////////////////////////////////////////// //

const getBuildInfo = () => {
  return `folder_picker_v${PackageJson.version.replace(/\./g, '')}`;
};

let prevRegion: string = 'US';

const getSDK = ({ region }: { region: string }): DocsClass => {
  prevRegion = region;
  return new DocsClass({
    region,
    env: getEnv(),
    partition: getPartition(),
    getToken: getCurrentToken,
    buildId: getBuildInfo(),
    product: DOCS_PRODUCTS.ACC
  });
};

let instance: DocsClass = getSDK({ region: getRegion() });

const getServices = () => {
  return {
    Projects: instance.Projects,
    Users: instance.Users,
    Folders: instance.Folders,
    VirtualFolders: instance.VirtualFolders,
    Instance: instance
  };
};

// eslint-disable-next-line import/no-mutable-exports
let services = getServices();

const updateSDK = (options?: { region?: string }): void => {
  const region = options?.region || getRegion();
  if (region === prevRegion) return;
  instance = getSDK({ region });
  // need to update the services singleton as well after the instance is updated
  services = getServices();
};

export { services as default, updateSDK };
